/* eslint-disable react/prop-types */
import { Alert, AlertDescription, AlertIcon, AlertTitle, Link, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

function AlertFront({ title, link, linkTitle }) {
  const { t } = useTranslation()
  return (
    <Alert
      status="warning"
      h={['30px', '30px', '40px']}
      overflowX="auto"
    >
      <AlertIcon />
      <AlertTitle fontSize={['2xs', 'sm', 'sm']} noOfLines={1}>
        {t('attention')}! 📢
      </AlertTitle>
      <AlertDescription fontSize={['2xs', 'sm', 'sm']} noOfLines={1}>
        <Text>
          {title} <n />
          {link && (
            <Link
              href={link}
              color="blue.600"
              fontStyle={'italic'}
              fontWeight={'bold'}
              cursor="pointer"
            >
            
              {linkTitle}
            </Link>
          )}

        </Text>
      </AlertDescription>
    </Alert>
  )
}

export default AlertFront